<template>
<tr v-if="contractExist">
    <td>
        <input type="checkbox" class="singleCheckbox" style="margin-left:-10px;">
    </td>
    <td class="fw-bold" @click="$emit('open-view-modal', room)">
        {{ room.name }}
    </td>
    <td @click="$emit('open-view-modal', room)">
        <h4>
            <div class="badge p-1" :class="statusClass" style="margin-top: -0.2rem;">{{ statusText }}</div>
        </h4>
    </td>
    <td @click="$emit('open-view-modal', room)">
        <div>{{ guest.name }}</div>
    </td>
    <td>
        <div class="col-auto" v-if="guest.pay_btn_view && currentMonthPayment">
            <input type="checkbox" :id="`switch_${idx}`" :data-switch="payOnLabelColor" :checked="guest.is_checked" @change="changePayment($event)" />
            <label :for="`switch_${idx}`" :data-on-label="payOnLabel" :data-off-label="payOffLabel" class="mt-1"></label>
        </div>
        <div v-else @click="$emit('open-view-modal', room)">
            &nbsp;
        </div>
    </td>
    <td @click="$emit('open-view-modal', room)">
        {{ contractDate }}
    </td>
    <td @click="$emit('open-view-modal', room)">
        <span class="font-12 fw-light">
            {{ checkDate }}
        </span>
    </td>
    <td @click="$emit('open-view-modal', room)">
        <span class="font-12 fw-light" :class="leftDateClass" v-if="guest.status === 'entrance'">
            남은 일 수 : {{ leftDate }}
        </span>
        <span class="font-12 fw-light" v-else-if="guest.status === 'expired'">
            {{ emptyDate }}
        </span>
    </td>
    <td @click="$emit('open-view-modal', room)">
        매월 {{ textMonthPayDate }}
    </td>
    <td @click="$emit('open-view-modal', room)">
        {{ totalPrice }}만원
    </td>
    <td>
        <a :href="`tel:${guest.phone_no}`" class="text-secondary">
            {{ guest.phone_no }}
        </a>
    </td>
    <td>
        <button type="button" class="btn btn-sm btn-outline-secondary font-13 me-1" @click="$emit('open-register-modal', room, false)">
            <i class="mdi mdi-home-import-outline"></i> 추가
        </button>
        <button type="button" class="btn btn-sm btn-outline-primary font-13 me-1" @click="$emit('open-view-modal', room)">
            <i class="mdi mdi-file-outline"></i> 상세
        </button>
        <button type="button" class="btn btn-sm btn-outline-info font-13 me-1" @click="$emit('open-register-modal', room, true)">
            <i class="mdi mdi-file-edit-outline"></i> 수정
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger font-13" @click="$emit('open-del-modal', room)">
            <i class="mdi mdi-delete-alert-outline"></i> 삭제
        </button>
    </td>
</tr>
<tr v-else @click="$emit('open-register-modal', room, false)">
    <td>
        <input type="checkbox" class="singleCheckbox" style="margin-left:-10px;">
    </td>
    <td class="fw-bold">
        {{ room.name }}
    </td>
    <td>
        <h4>
            <div class="badge p-1" :class="statusClass" style="margin-top: -0.2rem;">{{ statusText }}</div>
        </h4>
    </td>
    <td class="custom-text-align" colspan="15">
        등록된 계약이 존재하지 않습니다.
    </td>
</tr>
</template>

<script>
import {
    DATE_FORMAT,
    DATE_DIFF
} from "@/config/date.js";
import dayjs from "dayjs";

export default {
    props: ["room", "today", "idx"],
    async mounted() {
        const payment = this.currentMonthPayment;

        if (payment) {
            // * 완납인 경우
            const condition_1 = payment.paid_status === "PAID_COMPLETE";

            // * 수납 이력이 존재하면서, 수납 토탈 금액이 0 이상일 경우
            const condition_2 = payment.paid_at && payment.paid_total > 0;

            if (condition_1 || condition_2) {
                this.room.recent_guest.is_checked = true;
            } else {
                this.room.recent_guest.is_checked = false;
            }
        } else {
            this.room.recent_guest.is_checked = false;
        }
    },
    computed: {
        guest() {
            return this.room.recent_guest;
        },
        statusClass() {
            switch (this.guest.status) {
                case "entrance":
                    return "bg-success";
                case "expired":
                    return "bg-danger";
                case "waiting":
                    return "bg-primary";
                default:
                    return "bg-secondary";
            }
        },
        statusText() {
            switch (this.guest.status) {
                case "entrance":
                    return "입실";
                case "expired":
                    return "공실";
                case "waiting":
                    return "예약";
                default:
                    return "알 수 없음";
            }
        },
        currentMonthPayment() {
            const currentMonth = this.today.format("YYYY-MM");
            return this.guest.guest_payment.find(payment => payment.paid_year_month === currentMonth);
        },
        payOnLabel() {
            const payment = this.currentMonthPayment;

            if (!payment) {
                return "수납";
            }

            // 완납인 경우
            if (payment.paid_status === "PAID_COMPLETE") {
                return payment.paid_total > this.totalPrice ? "초과" : "수납";
            }

            // 수납 이력이 존재하고, 토탈 금액이 0 이상일 떄
            if (payment.paid_at && payment.paid_total > 0) {
                return "일부";
            }

            return "수납";
        },
        payOnLabelColor() {
            const payment = this.currentMonthPayment;

            if (!payment) {
                return "success";
            }

            // 완납인 경우
            if (payment.paid_status === "PAID_COMPLETE") {
                return payment.paid_total > this.totalPrice ? "primary" : "success";
            }

            // 수납 이력이 존재하고, 토탈 금액이 0 이상일 떄
            if (payment.paid_at && payment.paid_total > 0) {
                return "warning";
            }

            return "success";
        },
        payOffLabel() {
            const payment = this.currentMonthPayment;

            if (!payment || payment.paid_status === "PAID_COMPLETE") {
                return ""; // 결제 정보가 없거나 완납 상태인 경우 빈 문자열 반환
            }

            // 수납 예정일이 오늘보다 이전인 경우는 "미납", 오늘보다 이후면 "수납 예정"
            return dayjs(payment.paid_date).isBefore(this.today, "day") ? "미납" : "예정";
        },
        emptyDate() {
            return `${DATE_DIFF( this.guest.end_date, this.today)}일째 공실`;
        },
        leftDate() {
            return this.guest.end_date ? `${DATE_DIFF(this.today, this.guest.end_date) + 1}일` : "미정";
        },
        leftDateClass() {
            const remainingDays = this.guest.end_date ? DATE_DIFF(this.today, this.guest.end_date) + 1 : null;
            return remainingDays !== null && remainingDays <= 3 ? "text-danger fw-bold" : "";
        },
        checkDate() {
            let diff = "";
            switch (this.guest.status) {
                case "entrance":
                    diff = DATE_DIFF(this.guest.start_date, this.today) + 1;
                    return `${diff}일째 거주 중`;
                case "expired":
                    if (this.guest.end_date) {
                        diff = DATE_DIFF(this.guest.start_date, this.guest.end_date);
                        return `${diff}일 거주 후, 퇴실`;
                    }
                    return "";
                case "waiting":
                    diff = DATE_DIFF(this.today, this.guest.start_date) + 1;
                    return `입주 D-${diff}`
                default:
                    return "";
            }
        },
        contractExist() {
            return this.guest.hasOwnProperty("pk");
        },
        contractDate() {
            if (this.guest.start_date) {
                return `${DATE_FORMAT(this.guest.start_date, "short")} ~ ${this.guest.end_date ? DATE_FORMAT(this.guest.end_date, "short") : "종료일 미정"}`;
            } else {
                return "";
            }
        },
        totalPrice() {
            const price = this.guest.price || 0;
            const maintenance = this.guest.maintenance_price || 0;
            let total = price + maintenance;

            if (this.guest.vat === "vat_price") {
                total = (price * 1.1) + maintenance;
            } else if (this.guest.vat === "vat_all") {
                total = (price + maintenance) * 1.1;
            }

            return Number.isInteger(total) ? total : total.toFixed(1);
        },
        textMonthPayDate() {
            return `${this.guest.month_pay_date}일${this.guest.month_pay_date === 31 ? " (말일)" : ""}`;
        }
    },
    methods: {
        changePayment(event) {
            const checked = event.target.checked;
            event.target.checked = this.guest.is_checked;
            this.$emit("toggle-payment", this.room, this.currentMonthPayment, checked);
        }
    }
}
</script>

<style>
.bg-orange {
    background-color: #FFA500;
}

.custom-text-align {
    text-align: center;
}

@media (max-width: 767.98px) {
    .custom-text-align {
        text-align: left;
    }
}
</style>
